import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const locales = [];
const messages = {};

locales.forEach((v) => {
  messages[v] = require(`./${v}/index`).default; // eslint-disable-line
});
const i18n = new VueI18n({
  locale: 'es',
  silentTranslationWarn: true,
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js